import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

const ProjectSelectDialog = ({ open, onClose, projects, onSelect }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select a Project</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please select a project to continue
        </Typography>
        <List>
          {projects.map((project) => (
            <ListItem key={project.id} disablePadding>
              <ListItemButton onClick={() => onSelect(project)}>
                <ListItemText 
                  primary={project.name}
                  secondary={project.description}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectSelectDialog; 